import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueClipboards from "vue-clipboards";
import VueNativeSock from 'vue-native-websocket'
import store from './stores'
import { router } from './_helpers';

Vue.config.devtools = true

Vue.use(VueClipboards);



Vue.config.productionTip = false


// Use vue-native-websocket plugin
const wsUrl = process.env.VUE_APP_WS_URL || '192.168.1.31:8090'
const wsString = process.env.NODE_ENV === 'production' ? `wss://${wsUrl}/ws/` : `ws://${wsUrl}/ws/`
Vue.use(VueNativeSock, wsString,{
  store: store,
  reconnection: true,
  reconnectionAttempts: 30 // timeout 1sec
})


new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
